<template>
  <section class="home-operation home-container">
    <h3 class="home-title">平台用例</h3>
    <div class="home-operation__container">
      <button
        class="product-operationContainer__btn el-icon-arrow-left"
        data-btn-type="prev"
        data-disabled="true"
        @click="changeItem('prev')"
      ></button>
      <button
        class="product-operationContainer__btn el-icon-arrow-right"
        data-btn-type="next"
        @click="changeItem('next')"
      ></button>
      <div class="homeOperation-item" v-for="(item,index) in operationLists" :key="index">
        <p class="homeOperation-item__iconContainer">
          <span class="homeOperation-item__icon">
            <img :src="item.img" :alt="item.title" class="homeOperation-item__icon_img" />
          </span>
        </p>
        <div class="homeOperation-item__right">
          <h4 class="homeOperation-item__right_title">{{ item.title }}</h4>
          <div class="homeOperation-item__right_content" :title="item.content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "home-operation",
  data() {
    return {
      operationLists: [
        {
          title: "模型训练",
          content: "提供AI训练任务对模型进行训练，支持深度学习分布式训练，可视化部署训练作业",
          img: require("../../assets/images/modeltraining.png")
        },
        {
          title: "模型管理",
          content: "平台模型管理系统管理训练好的模型，支持多版本管理，下载，分享等功能",
          img: require("../../assets/images/modelmanage.png")
        },
        {
          title: "部署服务",
          content: "将模型发布为AI服务，通过部署到PaaS平台提供AI能力或者将模型部署至边缘平台",
          img: require("../../assets/images/deployservice.png")
        },
        {
          title: "数据源",
          content: "开提供多种数据源接入方式，也可将原始数据一键导入到平台",
          img: require("../../assets/images/datasource.png")
        },
        {
          title: "数据预处理",
          content: "支持对原始数据在线清洗脏数据，提供现在标注工具",
          img: require("../../assets/images/pretreatment.png")
        },
        {
          title: "模型开发",
          content: "提供开箱即用的AI训练环境以及融合的Mlab在线开发工具",
          img: require("../../assets/images/modeldevelop.png")
        }
      ],
      snap: null
    };
  },
  props: {},
  inject: ["snapScroll"],
  mounted: function() {
    let container = document.querySelector(".home-operation__container");
    let prevBtn = document.querySelector(
      ".product-operationContainer__btn[data-btn-type='prev']"
    );
    let nextBtn = document.querySelector(
      ".product-operationContainer__btn[data-btn-type='next']"
    );
    this.snap = new this.snapScroll({ container, prevBtn, nextBtn });
  },
  methods: {
    changeItem: function(type) {
      this.snap.btnClick(type);
    }
  }
};
</script>

<style scoped>
.home-operation {
  position: relative;
}
.home-operation__container {
  width: 85%;
  padding-top: 6.666666666666667vw;
  margin: 0 auto;
  overflow-x: auto;
  font-size: 0;
  white-space: nowrap;
  text-align: left;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.home-operation__container::-webkit-scrollbar {
  display: none;
}
.homeOperation-item {
  display: inline-block;
  width: calc((100% - 2.6666666666666665vw) / 2);
  padding: 0 0 3vw;
  text-align: center;
  background: #f1f7ff;
  transition: 1s;
  scroll-snap-align: start;
  cursor: pointer;
}
.homeOperation-item + .homeOperation-item {
  margin-left: 2.6666666666666665vw;
}
.homeOperation-item__iconContainer {
  width: 13.333333333333334vw;
  height: 13.333333333333334vw;
  margin: 0 auto;
}
.homeOperation-item__icon {
  position: relative;
  display: block;
  width: 100%;
  /*height: 100%;*/
  border-radius: 50%;
  margin-top: -50%;
  overflow: hidden;
  line-height: 13.333333333333334vw;
  text-align: center;
  background: #f1f7ff;
  box-shadow: 0vw 0.8vw 1.0666666666666667vw 0vw rgba(5, 1, 1, 0.06);
  transition: 1s;
}
.homeOperation-item:hover .homeOperation-item__icon,
.homeOperation-item[data-ifActive="true"] .homeOperation-item__icon {
  box-shadow: none;
}
.homeOperation-item__icon_img {
  width: 6.666666666666667vw;
}
.homeOperation-item__right {
  margin-top: 2.1333333333333333vw;
  font-size: 3.2vw;
  color: #575a66;
  transition: 1s;
}
.homeOperation-item__right_title {
  font-size: 1.33333em;
  line-height: 1;
  color: #333;
  transition: 1s;
}

.homeOperation-item__right_content {
  height: 21vw;
  padding: 0 1em;
  margin-top: 0.5em;
  overflow: hidden;
  line-height: 1.2;
  white-space: normal !important;
  text-align: left;
  /*text-overflow: ellipsis;*/
}

.product-operationContainer__btn {
  position: absolute;
  font-size: 10vw;
  color: #043f6a;
  background: transparent;
  cursor: pointer;
}
.product-operationContainer__btn:not([data-disabled="true"]):active {
  filter: drop-shadow(0.26666666666666666vw 0.5333333333333333vw 0.5333333333333333vw black);
}
.product-operationContainer__btn[data-disabled="true"] {
  opacity: 0.2;
  cursor: not-allowed;
}

.product-operationContainer__btn[data-btn-type="prev"] {
  left: 0;
  margin-top: 13.333333333333334vw;
  transform: translate(0, -50%);
}
.product-operationContainer__btn[data-btn-type="next"] {
  right: 0;
  margin-top: 13.333333333333334vw;
  transform: translate(0, -50%);
}
</style>
<style type="text/css">
.st0 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 12;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st1 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 6;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-dasharray: 17;
}
.st2 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st3 {
  display: none;
  fill: none;
  stroke: #ff7e00;
  stroke-width: 6;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-dasharray: 17;
}
.st4 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 9;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st5 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 12;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
.st6 {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 8;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/ai-platform-example.vue